// ============================================
// GameLoop - Bucle principal del juego
// ============================================

export class GameLoop {
  private lastTime = 0;
  private running = false;
  private frameId: number | null = null;

  constructor(
    private update: (deltaTime: number) => void,
    private render: () => void
  ) {}

  start(): void {
    if (this.running) return;
    this.running = true;
    this.lastTime = performance.now();
    this.loop();
  }

  stop(): void {
    this.running = false;
    if (this.frameId !== null) {
      cancelAnimationFrame(this.frameId);
      this.frameId = null;
    }
  }

  private loop = (): void => {
    if (!this.running) return;

    const currentTime = performance.now();
    const deltaTime = (currentTime - this.lastTime) / 1000;
    this.lastTime = currentTime;

    // Limitar delta time para evitar saltos grandes
    const clampedDelta = Math.min(deltaTime, 0.1);

    this.update(clampedDelta);
    this.render();

    this.frameId = requestAnimationFrame(this.loop);
  };

  isRunning(): boolean {
    return this.running;
  }
}
